// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__eubMY","content":"styles_content__CTN0L"};